import loginEpics from "../screens/login/epics"
import logoutEpics from "../layouts/header/epics"
import authEpics from "../auth/epics"
import categoriesEpics from "../screens/categories/itemsCategories/epics"
import menuDataInvalidationEpics from "../screens/categories/invalidation-epics"
import itemsAndCategoriesTableEpics from "../screens/categories/itemsCategories/table/epics"
import itemsAndCategoriesDetailEpics from "../screens/categories/itemsCategories/detail/epics"
import categoryGroupsEpics from "../screens/categories/optionGroups/epics"
import schematizedEpics from "../screens/salesInput/schematized/epics"
import operationsEpics from "../operations/epics"
import dataEpics from "../data/epics"
import modifierEpics from "../screens/categories/modifiers/epics"
import routerEpics from "../router/epics"
import modifierGroupEpics from "../screens/categories/modifierGroups/epics"
import locationsEpics from "../screens/locations/epics"
import locationsEpicsOld from "../screens/locations/epics_old"
import googleBusinessOAuthEpics from "../screens/locations/googleBusiness/epics"
import assignmentsEpics from "../screens/assignments/epics"
import pricingEpics from "../screens/pricingsAndPromotions/pricing/epics"
import customersReportEpics from "../screens/reports/customers/customersTable/epics"
import googleBusinessReviewEpics from "../screens/reports/customers/googleReviews/epics"
import customersFeedbackReportEpics from "../screens/reports/customers/customersFeedback/epics"
import ordersReportEpics from "../screens/reports/orders/epics"
import cashReportEpics from "../screens/reports/cash/epics"
import preparationTimeEpics from "../screens/reports/preparationTime/epics"
import specialPricingEpics from "../screens/reports/specialPricing/epics"
import voidsEpics from "../screens/reports/voids/epics"
import reportsEpics from "../screens/reports/epics"
import summaryReportEpics from "../screens/reports/summary/epics"
import extensiveReportsEpics from "../screens/reports/extensiveReports/epics"
import transactionsReportEpics from "../screens/reports/transactions/epics"
import timesheetReportEpics from "../screens/reports/timesheet/epics"
import filtersEpics from "../filters/epics"
import rolesEpics from "../screens/roles/epics"
import employeeEpics from "../screens/employees/employees/epics"
import passwordEpics from "../screens/passwordResetUser/epics"
import signUpEpics from "../screens/signUp/epics"
import passwordResetRequestEpics from "../screens/passwordResetRequest/epics"
import settingEpics from "../screens/settings/epics"
import paymentsSettingsEpics from "../screens/settings/paymentSettings/epics"
import loyaltyProgramEpics from "../screens/settings/loyaltyProgram/epics"
import invetoryEpics from "../screens/inventory/epics"
import consoleEpics from "../screens/console/epics"
import deliverySettingsEpics from "../screens/settings/deliverySettings/epics"

export default [
    ...filtersEpics,
    ...loginEpics,
    ...logoutEpics,
    ...authEpics,
    ...categoriesEpics,
    ...menuDataInvalidationEpics,
    ...itemsAndCategoriesTableEpics,
    ...itemsAndCategoriesDetailEpics,
    ...modifierEpics,
    ...categoryGroupsEpics,
    ...schematizedEpics,
    ...operationsEpics,
    ...dataEpics,
    ...modifierGroupEpics,
    ...routerEpics,
    ...locationsEpics,
    ...locationsEpicsOld,
    ...googleBusinessOAuthEpics,
    ...googleBusinessReviewEpics,
    ...assignmentsEpics,
    ...pricingEpics,
    ...voidsEpics,
    ...customersReportEpics,
    ...customersFeedbackReportEpics,
    ...ordersReportEpics,
    ...cashReportEpics,
    ...preparationTimeEpics,
    ...specialPricingEpics,
    ...reportsEpics,
    ...summaryReportEpics,
    ...extensiveReportsEpics,
    ...transactionsReportEpics,
    ...timesheetReportEpics,
    ...employeeEpics,
    ...passwordEpics,
    ...rolesEpics,
    ...signUpEpics,
    ...passwordResetRequestEpics,
    ...settingEpics,
    ...paymentsSettingsEpics,
    ...loyaltyProgramEpics,
    ...invetoryEpics,
    ...consoleEpics,
    ...deliverySettingsEpics,
]
